namespace Solovis.Site.Search {

    export var maxItemsInExtendedSearchResultsDialog: number = 500;

}